$(function () {
  var legendCallback = function(chart) {
    var text = [];
    text.push('<ul class="bar-chart__legend-list ' + chart.id + '-legend">');
    for (var i = 0; i < chart.data.datasets.length; i++) {
      var label = chart.data.datasets[i].label;
      text.push('<li>');
      text.push('<div class="chart__icon-wrapper"><div class="chart__legend-icon" style="background-color:'
          + chart.data.datasets[i].backgroundColor + '"></div></div>');
      if (label) {
        text.push('<div class="chart__legend-text"><span>' + label + '</span></div>');
      }
      text.push('</li>');
    }
    text.push('</ul>');

    return text.join("");
  };

  var animationCompleteCallback = function() {
    var chartInstance = this.chart;
    var ctx = chartInstance.ctx;
    var smallText = Chart.helpers.fontString(10, 'normal', '"Titillium Web", "Helvetica Neue", "Arial", sans-serif');
    var normalText = Chart.helpers.fontString(14, 'normal', '"Titillium Web", "Helvetica Neue", "Arial", sans-serif');
    ctx.textBaseline =  'middle';
    var baselineShift;
    Chart.helpers.each(this.data.datasets.forEach(function (dataset, i) {
      var meta = chartInstance.controller.getDatasetMeta(i);
      Chart.helpers.each(meta.data.forEach(function (bar, index) {
        ctx.save();
        // decide which font size to use
        if (bar._xScale.maxWidth < 400) {
          baselineShift = -3.5;
          ctx.font = smallText;
        } else {
          baselineShift = -4;
          ctx.font = normalText;
        }

        var x_pos = bar._model.x + 4;
        // If bar is not high enough, move datatext out of the bar.
        if ((bar._yScale.maxHeight - bar._model.y) <= 47) {
          ctx.translate(x_pos, bar._model.y - 15);
          ctx.fillStyle = 'Black';
          ctx.textAlign = 'left';
        // If not, show datatext inside of the bars.
        } else {
          ctx.translate(x_pos, bar._model.y + 15);
          ctx.fillStyle = "White";
          ctx.textAlign = 'right';
        }
        // Rotate context by -90 degrees
        ctx.rotate(-0.5 * Math.PI);
        // Draw text
        var value = Math.round(dataset.data[index]).toLocaleString('en', { delimiter: ','} );
        ctx.fillText(value, 0, baselineShift);
        ctx.restore();
      }),this);
    }),this);
  };

  $('[data-behavior=bar-chart]').existsEach(function ($barChart) {
    var dataAttr = $barChart.data('bar-chart');

    var datasets = dataAttr.datasets;
    var labels = dataAttr.labels;

    var legendContainer = $barChart.find(dataAttr.legend);
    var canvas = $barChart.find('canvas');


    var barChart = new Chart(canvas, {
      type: 'bar',
      data: {
          labels: labels,
          datasets: datasets
      },
      options: {
        tooltips: {
          enabled: false
        },
        legendCallback: legendCallback,
        animation: {
          onComplete: animationCompleteCallback
        },
        hover: {
          animationDuration: 0
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            display: true,
            ticks: {
              suggestedMin: 0,
              callback: function(value, index, values) {
                return value.toLocaleString();
              }
            }
          }]
        }
      }
    });
    $(legendContainer).html(barChart.generateLegend());
  });

  $('[data-behavior=bar-chart-right]').existsEach(function ($barChart) {
    var dataAttr = $barChart.data('bar-chart');

    var datasets = dataAttr.datasets;
    var labels = dataAttr.labels;

    var legendContainer = $barChart.find(dataAttr.legend);
    var canvas = $barChart.find('canvas');


    var barChart = new Chart(canvas, {
      type: 'bar',
      data: {
          labels: labels,
          datasets: datasets
      },
      options: {
        tooltips: {
          enabled: false
        },
        legendCallback: legendCallback,
        animation: {
          onComplete: animationCompleteCallback
        },
        hover: {
          animationDuration: 0
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            position: 'right',
            ticks: {
              suggestedMin: 0,
              callback: function(value, index, values) {
                return value.toLocaleString();
              }
            }
          }]
        }
      }
    });
    $(legendContainer).html(barChart.generateLegend());
  });
});
